import React from 'react';
import {Grid2 as Grid, Typography} from "@mui/material";

const _epTitr6 = (titr) => {
    return (

        <Grid sx={{mx:3}}>
            <Typography sx={{fontWeight:600}} >{titr?.Title}</Typography>
        </Grid>
    );
};

export default _epTitr6;
